export default __webpack_public_path__ + "static/gs-6-explainmodel-16f5d3297dba89ba7afd3ef4116de217.jpg";